import React from 'react';
import { Link } from 'react-router-dom';

const GoogleMapView = ({address} : {address: string}) => {
  const googleMapUrl = `https://www.google.com/maps/search/${address}`;

  return (
    <Link to={googleMapUrl} target='_blank'>{address}</Link>
  );
}

export default GoogleMapView;